<template>
    <!-- Copyright Start -->
    <div class="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s">
        <div class="container py-5">
            <div class="row g-5">
                <div class="col-md-6 col-lg-6 col-xl-3">
                    <div class="footer-item d-flex flex-column">
                        <h4 class="text-white mb-4 pmisputih">MIS NUFReP</h4>
                        <p>National Urban Flood Resilience Project</p>
                        <a href="https://www.instagram.com/berita.nufrep/" target="_blank"><i class="fab fa-instagram me-2"></i> Berita NUFReP</a>
                        <a href="https://www.youtube.com/@PMCNUFReP2025" target="_blank"><i class="fab fa-youtube-square me-2"></i> Youtube NUFReP</a>
                    </div>
                </div>
                <div class="col-md-3 text-center text-md-start mb-md-0">
                    <a href="#" class="mb-4 text-white pmisputih">
                        <h4 class="mb-4 text-white pmisputih" v-if="(bahasa === null) || (bahasa == 'ina')">Jumlah
                            Pengunjung</h4>
                        <h4 class="mb-4 text-white pmisputih" v-else>Number of visitors</h4>
                    </a>
                    <a href="#" class="text-white">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Hari ini: {{ G_numFormat(harini) }}</span>
                        <span v-else>Today: {{ G_numFormat(harini) }}</span>
                    </a><br>
                    <a href="#" class="text-white">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Bulan ini: {{ G_numFormat(bulanini)
                        }}</span>
                        <span v-else>This month: {{ G_numFormat(bulanini) }}</span>
                    </a><br>
                    <a href="#" class="text-white">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Tahun ini: {{ G_numFormat(tahunini)
                        }}</span>
                        <span v-else>This year: {{ G_numFormat(tahunini) }}</span>
                    </a>
                    <br>
                    <a href="#" class="text-white">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Total Pengunjung: {{
                            G_numFormat(totalpengunjung) }}</span>
                        <span v-else>Total visitor: {{ G_numFormat(totalpengunjung) }}</span>
                    </a>
                </div>
                <div class="col-md-3 text-center text-md-start mb-md-0">
                    <div class="footer-item d-flex flex-column">
                        <h4 class="mb-4 text-white pmisputih">
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">Tautan</span>
                        </h4>
                        <a href="https://pu.go.id/" target="_blank"><i class="fas fa-angle-right me-2"></i> Kementerian
                            PUPR</a>
                        <a href="https://sda.pu.go.id/" target="_blank"><i class="fas fa-angle-right me-2"></i> Ditjen
                            SDA Kementerian PUPR</a>
                        <a href="https://iemon.pu.go.id/" target="_blank"><i class="fas fa-angle-right me-2"></i>
                            Emonitoring PUPR</a>
                        <a href="https://pdsda.sda.pu.go.id/" target="_blank"><i class="fas fa-angle-right me-2"></i>
                            WRDC</a>
                        <a href="http://103.122.35.24/loginpaksi.html" target="_blank"><i
                                class="fas fa-angle-right me-2"></i> E-PAKSI</a>
                        <a href="https://iemon.sisda.net/" target="_blank"><i class="fas fa-angle-right me-2"></i> Loan
                            Management System</a>
                        <a href="https://pmisv2.sisda.net/" target="_blank"><i class="fas fa-angle-right me-2"></i> PMIS
                            SISDA V2</a>
                        <a href="https://pmis.sisda.net/" target="_blank"><i class="fas fa-angle-right me-2"></i> PMIS
                            SISDA V3</a>
                    </div>
                </div>
                <div class="col-md-3 text-center text-md-start mb-md-0">
                    <div class="footer-item d-flex flex-column">
                        <h4 class="mb-4 text-white pmisputih">
                            Info Kontak
                        </h4>
                        <a href=""><i class="fas fa-house-user me-2"></i> PMC NUFReP</a>
                        <a href=""><i class="fa fa-map-marker-alt me-2"></i> Gedung Ditjen Sumber Daya Air - Kementerian
                            PUPR - JL. Pattimura 20, Kebayoran Baru, Jakarta - Indonesia - 12110</a>
                        <a href=""><i class="fas fa-envelope me-2"></i> pmc.nufrep@gmail.com</a>
                        <a href=""><i class="fas fa-phone me-2"></i> (021) 48679407</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid copyright py-4">
        <div class="container">
            <div class="row g-6 align-items-center">
                <div class="col-md-4 text-center text-md-start mb-md-0">
                    <span class="text-white">
                        <a href="#" class="merahmaroon">
                            <i class="fas fa-copyright text-light me-2"></i> <span class="text-warning">#MIS NUFReP
                                V.1.1</span>
                        </a>
                        &nbsp;{{ tahun }} All right reserved.
                    </span>
                </div>
                <div class="col-md-12 text-center text-md-start mb-md-0 text-white">
                    Designed By <a href="https://sda.pu.go.id/" target="_blank"><span class="text-warning"> Ditjen SDA
                            Kementerian PUPR </span> </a>
                </div>
            </div>
        </div>
    </div>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <!-- Copyright End -->
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';

export default {
    components: {
        swal
    },
    data() {
        return {
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            datapesan: '',
            harini: 0,
            bulanini: 0,
            tahunini: 0,
            totalpengunjung: 0,
            project_id: process.env.VUE_APP_PROJECT_ID,
        };
    },
    methods: {
        async ambildata() {
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationVisitor-GetVisitor?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.harini = Response.data.hariini;
                        this.bulanini = Response.data.bulanini;
                        this.tahunini = Response.data.tahunini;
                        this.totalpengunjung = Response.data.total;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style></style>